import axios from "./axios";

const api = {
    app: {
        getActivityLogs: (params, $config) => axios.get("/user/activity", { params }, $config),
        markOne: (id, $body, $config) => axios.patch(`/user/activity/${id}/mark-one`, $body, $config),
        markAll: ($body, $config) => axios.patch("/user/activity/mark-all-read", $body, $config),
        getProjectCount: ($body, $config) => axios.get("/user/projects/completed-count", $body, $config),
        fetchUnreadCount: ($body, $config) => axios.get("/user/activity/count", $body, $config),
        checkUpgradeStatus: (params, $config) => axios.get("/user/users/check-upgrade", { params }, $config),
        reportBugs: ($body, params, $config) => axios.post("/user/users/bugs", $body, { params }, $config),
        getSignedUrl: ($body, params, $config) => axios.post("/user/uploads/get-signed-url", $body, { params }, $config),
        validateMockSignedUrl: ($body, params, $config) => axios.put("/user/uploads//validate-test-url", $body, { params }, $config),
        removeUpload: ($body, params, $config) => axios.put("/user/uploads/remove", $body, { params }, $config),
        fetchPublicProfile: (params, $config) => axios.get("/public/profile", { params }, $config),
        sendSupportEmail: ($body, $config) => axios.post("/public/support", $body, $config),
    },

    auth: {
        externalLogin: ($body, $config) => axios.post("/user/auth/external-auth", $body, $config),
        initiatePasswordReset: ($body, $config) => axios.post("/user/auth/initiate-reset", $body, $config),
        login: ($body, $config) => axios.post("/user/auth/login", $body, $config),
        resetPassword: ($body, $config) => axios.put("/user/auth/reset-password", $body, $config),
        signup: ($body, params, $config) => axios.post("/user/auth/signup", $body, { params }, $config),
        verifyToken: ($body, $config) => axios.post("/user/auth/verify-token", $body, $config),
        logout: ($body, $config) => axios.get("/user/auth/logout", $body, $config),
    },

    calendar: {
        getPrimaryCalendar: (params, $config) => axios.get("/user/calendar/primary", { params }, $config),
    },

    client: {
        create: ($body, $config) => axios.post("/user/clients", $body, $config),
        getAll: (params, $config) => axios.get("/user/clients", { params }, $config),
        delete: ($body, $config) => axios.patch("/user/clients/delete", $body, $config),
        upload: ($body, params, $config) => axios.post("/user/clients/upload", $body, { params }, $config),
        followUp: ($body, $config) => axios.post("/user/clients/follow-up", $body, $config),        
        getOne: (id, $config) => axios.get(`/user/clients/${id}`, $config),
        updateOne: (id, $body, $config) => axios.put(`/user/clients/${id}`, $body, $config),
        duplicate: (id, $body, $config) => axios.post(`/user/clients/${id}/duplicate`, $body, $config),
        archive: (id, $body, $config) => axios.put(`user/clients/${id}/archive`, $body, $config),
        fetchStats: (params, $config) => axios.get("user/clients/stats", { params }, $config),
        fetchMostRecent: (params, $config) => axios.get("user/clients/most-recent", { params }, $config),

        // check-ins
        getCheckIns: (id, params, $config) => axios.get("/user/clients/check-ins", { params }, $config),
        addCheckIn: ($body, $config) => axios.post("/user/clients/check-ins", $body, $config),
        removeCheckIn: (id, $config) => axios.delete(`/user/clients/check-ins/${id}`, $config),  
        
        // projects
        getProjects: (id, params, $config) => axios.get(`/user/clients/${id}/projects`, { params }, $config),
        addProject: (id, $body, $config) => axios.put(`/user/clients/${id}/projects/${$body.projectId}`, $body, $config),
        removeProject: (id, params, $body, $config) => axios.delete(`/user/clients/${id}/projects/${$body.projectId}`, { params }, $config),  
        
        getInvoices: (id, params, $config) => axios.get(`/user/clients/${id}/invoices`, { params }, $config),
                
        getNotes: (id, params, $config) => axios.get(`/user/clients/${id}/notes`, { params }, $config),
        createNote: ($body, $config) => axios.post(`/user/clients/${$body.clientId}/notes`, $body, $config),
        editNote: (id, $body, $config) => axios.put(`/user/clients/${id}/notes/${$body._id}`, $body, $config),
        deleteNote: (id, $body, $config) => axios.delete(`/user/clients/${id}/notes/${$body._id}`, $config),

        // links
        fetchLinks: (id, $config) => axios.get(`/user/clients/${id}/links`, $config),
        manageLinks: (id, params, $body, $config) => axios.put(`/user/clients/${id}/links`, $body, { params }, $config),

    },

    config: {
        getAccountPlans: (params, $config) => axios.get("/public/account-plans", { params }, $config),
        getIntegrations: (params, $config) => axios.get("/config/integrations", { params }, $config),
    },

    integration: {
        getAll: (params, $config) => axios.get("/user/integrations", { params }, $config),
        initiate: ($body, $config) => axios.put("/user/integrations/initiate", $body, $config),
        enable: ($body, $config) => axios.post("/user/integrations/enable", $body, $config),
        disable: (id, $config) => axios.delete(`/user/integrations/${id}/disable`, $config),
    },

    invoice: {
        count: ($body, $config) => axios.get("/user/invoices/count", $body, $config),
        delete: ($body, $config) => axios.patch("/user/invoices/delete", $body, $config),
        download: (id, $config) => axios.get(`/user/invoices/${id}/download`, $config),
        draft: ($body, params) => axios.post("/user/invoices/draft", $body, { params }),
        duplicate: ($body, $config) => axios.post("/user/invoices/duplicate", $body, $config),
        getAll: (params) => axios.get("/user/invoices", { params }),
        getOne: (id, params, $config) => axios.get(`/user/invoices/${id}`, { params }, $config),
        send: ($body, $config) => axios.post("/user/invoices/send", $body, $config),
        updateOne: (id, $body, $config) => axios.put(`/user/invoices/${id}`, $body, $config),
        updateStatus: (id, $body, $config) => axios.put(`/user/invoices/${id}/update-status`, $body, $config),
        updateBillingData: (id, $body, $config) => axios.patch(`/user/invoices/${id}/billing-data`, $body, $config),
    },

    meeting: {
        getMeeting: (id, $config) => axios.get(`/user/meetings/${id}`, $config),
        getMeetings: (params, $config) => axios.get("/user/meetings", { params }, $config),
        addNew: ($body, $config) => axios.post("/user/meetings", $body, $config),
        editMeeting: (id, $body, $config) => axios.put(`/user/meetings/${id}`, $body, $config),
        deleteMeeting: (id, $config) => axios.delete(`/user/meetings/${id}`, $config),
        duplicate: ($body, $config) => axios.post("/user/meetings/duplicate", $body, $config),
        
        addNote: (id, $body, $config) => axios.post(`/user/meetings/${id}/notes`, $body, $config),
        editNote: (id, $noteId, $config) => axios.put(`/user/meetings/${id}/notes/${$noteId}`, $body, $config),
        deleteNote: (id, $noteId, $config) => axios.delete(`/user/meetings/${id}/notes/${$noteId}`, $config),
    },

    project: {
        archive: (id, $body, $config) => axios.put(`/user/projects/${id}/archive`, $body, $config),
        create: ($body, $config) => axios.post("/user/projects", $body, $config),
        delete: ($body, $config) => axios.patch("/user/projects/delete", $body, $config),
        getOne: (id, $config) => axios.get(`/user/projects/${id}`, $config),
        getAll: (params, $config) => axios.get("/user/projects", { params }, $config),
        updateOne: (id, $body, $config) => axios.put(`/user/projects/${id}`, $body, $config),
        duplicate: (id, $body, $config) => axios.post(`/user/projects/${id}/duplicate`, $body, $config),
        schedule: (id, $body, $config) => axios.put(`/user/projects/${id}/schedule`, $body, $config),
        start: (id, $body, $config) => axios.put(`/user/projects/${id}/start`, $body, $config),
        createNote: (id, $body, $config) => axios.post(`/user/projects/${id}/notes`, $body, $config),
        deleteNote: (id, $body, $config) => axios.delete(`/user/projects/${id}/notes/${$body._id}`, $config),
        editNote: (id, $body, $config) => axios.put(`/user/projects/${id}/notes/${$body._id}`, $body, $config),
        getNotes: (id, params, $config) => axios.get(`/user/projects/${id}/notes`, { params }, $body, $config),
        getTrackers: (id, params, $config) => axios.get(`/user/projects/${id}/trackers`, { params }, $body, $config),
        addTag: (id, $body, $config) => axios.post(`/user/projects/${id}/tags`, $body, $config),
        removeTag: (id, $config) => axios.delete(`/user/projects/${id}/tags`, $config),
        fetchMostRecent: (params, $config) => axios.get("user/projects/most-recent", { params }, $config),
        
        fetchLinks: (id, $config) => axios.get(`/user/projects/${id}/links`, $config),
        manageLinks: (id, params, $body, $config) => axios.put(`/user/projects/${id}/links`, $body, { params }, $config),
        
        getInvoices: (id, params, $config) => axios.get(`/user/projects/${id}/invoices`, { params }, $config),
        
        updateSub: (id, $body, $config) => axios.put(`/user/projects/${id}/subs`, $body, $config),
        
        fetchLogs: (id, params, $config) => axios.get(`/user/projects/${id}/logs`, { params }, $config),
        toggleLog: (id, $body, $config) => axios.post(`/user/projects/${id}/logs`, $body, $config),
        
        upload: ($body, $config) => axios.post("/user/clients/upload", $body, $config),
    },

    rateCard: {
        create: ($body, $config) => axios.post("/user/rate-cards", $body, $config),
        getAll: (params, $config) => axios.get("/user/rate-cards", { params }, $config),
        getOne: (id, $config) => axios.get(`/user/rate-cards/${id}`, $config),
        updateOne: (id, $body, $config) => axios.put(`/user/rate-cards/${id}`, $body, $config),
        delete: ($body, $config) => axios.patch("/user/rate-cards/delete", $body, $config),
        upload: ($body, $config) => axios.post("/user/rate-cards/upload", $body, $config),
        download: (id, params, $config) => axios.get(`/user/rate-cards/${id}/download`, { params }, $config),
        sendRateCard: ($body, $config) => axios.post("/user/rate-cards/send-rate-card", $body, $config),
        duplicate: (id, $config) => axios.post(`/user/rate-cards/${id}/duplicate`, $config),
    },

    revenue: {
        getStats: (params, $config) => axios.get("/user/revenue/stats", { params }, $config),
        getHistory: (params, $config) => axios.get("/user/revenue/list", { params }, $config),
        getGoals: (params, $config) => axios.get("/user/revenue/goals", { params }, $config),
        createGoal: ($body, $config) => axios.post("/user/revenue/goals", $body, $config),
        editGoal: (id, $body, $config) => axios.put(`/user/revenue/goals/${id}`, $body, $config),
        deleteGoal: (id, params, $config) => axios.delete(`/user/revenue/goals/${id}`, { params }, $config),
    },

    settings: {
        getGoals: (params, $config) => axios.get("/user/settings/goals", { params }, $config),
        getNotifications: (params, $config) => axios.get("/user/settings/notifications", { params }, $config),
        getSettings: (params, $config) => axios.get("/user/settings", { params }, $config),
        updateGoals: ($body, $config) => axios.put("/user/settings/goals", $body, $config),
        updateNotifications: ($body, $config) => axios.put("/user/settings/notifications", $body, $config),
        updateSettings: ($body, $config) => axios.put("/user/settings", $body, $config),
    },
    
    subscription: {
        cancelPlan: (id, $config) => axios.put("/user/subscriptions/plans/cancel", $config),
        getCards: ($config) => axios.get("/user/subscriptions/cards", $config),
        getPaymentHistory: (params, $config) => axios.get("/user/subscriptions/invoices", { params }, $config),
        getInvoice: (id, params, $config) => axios.get(`/user/subscriptions/invoices/${id}`, { params }, $config),
        getSubscriptionInfo: ($config) => axios.get("/user/subscriptions/plans", $config),
        initiateCharge: ($body, $config) => axios.post("/user/subscriptions/initiate-charge", $body, $config),
        removeCard: (id, $config) => axios.delete(`/user/subscriptions/cards/${id}`, $config),
        updateSubscriptionPlan: ($body, $config) => axios.put("/user/subscriptions/plans", $body, $config),
        updateSubscriptionInfo: (id, $body, $config) => axios.put(`/user/subscriptions/plans/${id}`, $body, $config),
        updateCard: (id, $body, $config) => axios.put(`/user/subscriptions/cards/${id}`, $body, $config),
        verifyCharge: ($body, $config) => axios.post("/user/subscriptions/verify-charge", $body, $config),
    },

    tag: {
        create: ($body, $config) => axios.post("/user/tags", $body, $config),
        getTags: (params, $config) => axios.get("/user/tags", { params }, $config),
        updateTag: (id, $body, $config) => axios.put(`/user/tags/${id}`, $body, $config),
        deleteTag: ($body, $config) => axios.patch("/user/tags/delete", $body, $config),
    },
    
    task: {
        addTask: ($body, $config) => axios.post("/user/tasks", $body, $config),
        deleteTask: (id, $config) => axios.delete(`/user/tasks/${id}`, $config),
        duplicateTask: ($body, $config) => axios.post("/user/tasks/duplicate", $body, $config),
        editTask: (id, $body, $config) => axios.put(`/user/tasks/${id}`, $body, $config),
        getTasks: (params, $config) => axios.get("/user/tasks", { params }, $config),
        getTask: (id, $config) => axios.get(`/user/tasks/${id}`, $config),
        modifyNotes: (id, $body, $config) => axios.put(`/user/tasks/${id}/notes`, $body, $config),
    },

    user: {
        addLinks: ($body, params, $config) => axios.post("/user/users/links/add", $body, { params }, $config),
        changePassword: ($body, $config) => axios.put("/user/users/change-password", $body, $config),
        delete: ($body, $config) => axios.delete("/user/users/delete", $body, $config),
        deleteLink: (id, params, $config) => axios.delete(`/user/users/links/${id}`, { params }, $config),
        fetchPublicProfile: (params, $config) => axios.get("/user/users/public-profile", { params }, $config),
        savePublicProfileUpdates: ($body, $config) => axios.put("/user/users/public-profile", $body, $config),
        get: (params, $config) => axios.get("/user/users/fetchprofile", { params }, $config),
        getCalendar: ($body, $config) => axios.post("/user/users/calendar", $body, $config),
        getReports: (params, $config) => axios.get("/user/users/reports", { params }, $config),
        downloadReports: (params, $config) => axios.get("/user/users/download-reports", { params }, $config),
        manageSkills: ($body, $config) => axios.put("/user/users/skills", $body, $config),
        onboardingChecks: ($body, $config) => axios.get("/user/users/onboarding-checks", $body, $config),
        update: ($body, $config) => axios.put("/user/users/editprofile", $body, $config),
        updateAccounts: ($body, params, $config) => axios.put("/user/users/accounts", $body, { params }, $config),
        updateCalendarProvider: (action, $body, $config) => axios.put(`/user/users/update-calendar-provider/${action}`, $body, $config),
        updateLinks: (id, $body, params, $config) => axios.put(`/user/users/links/${id}`, $body, { params }, $config),
        verifySession: ($body, $config) => axios.get("/user/users/check-session", $body, $config),
        updatePaymentLinks: ($body, params, $config) => axios.put("/user/users/payment-links", $body, { params }, $config),
    },

    waitlist: {
        joinWaitlist: ($body, $config) => axios.post("/user/waitlist/register", $body, $config),
    },
};

export default api;